<template>
  <div class="container">
    <div>
      <h1 class="pageTitle w-100 mt-5 mb-5" v-html="title"></h1>
      <ul style="list-style-type: none; width: 100%">
        <template v-for="(item, idx) in items">
          <li :key="idx">
            <div class="list-item-wrapper">
              <div class="title">
                <h3 v-if="item.title">
                  {{ ordered ? idx + 1 + ". " + item.title : item.title }}
                </h3>
              </div>
              <span
                class="list-item"
                :style="`color: ${colorSchema};`"
                v-html="item.text"
              ></span>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "text-list",
  props: {
    items: {
      type: Array,
      default: () => ["item 1", "item 2", "item 3"]
    },
    title: String,
    ordered: {
      type: Boolean,
      default: true
    },
    grid: {
      type: Object,
      default: () => ({
        backgroundColor: "#fff"
      })
    },
    actions: {
      type: Array
    },
    colorSchema: {
      required: false,
      type: String,
      default: "#717171"
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
p {
  outline: 0;
}
ul {
  padding: 0;
  margin: 0;
  font-family: "Plus Jakarta Sans";
  // color: var(--brand-color);

  .title {
    // .titleBackground {
    //   width: 28px;
    //   height: 28px;
    //   border-radius: 50%;
    //   background-color: black;
    //   opacity: 0.1;
    //   position: absolute;
    //   z-index: -1;
    // }
    display: flex;
    align-items: center;
    text-align: left;
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 20px;
    @media (max-width: 767px) {
      margin-bottom: 15px;
      h3 {
        font-size: 18px;
      }
    }
  }
  .list-item-wrapper {
    margin-top: 24px;
    white-space: initial;

    .list-item {
      font-weight: normal;
      white-space: initial;
      font-size: 17px;
      line-height: 26px;
      max-width: calc(100% - 30px);
      word-wrap: break-word;

      @media (max-width: 767px) {
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 425px) {
  h2 {
    font-size: 23px !important;
  }
}
</style>
